import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
export default class LeftWhiteArrow extends Component {
    render() {
        return (_jsx("svg", Object.assign({ width: "16", height: "15", viewBox: "0 0 16 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m 6.9110287,0 1.80014,1.68169 -4.95525,4.62918 H 15.957625 V 8.68913 H 3.7559187 L 8.7111687,13.3183 6.9110287,15 0.8499187,9.32493 c -1.0551,-0.98788 -1.0551,-2.66198 0,-3.64986 z", fill: "#ffffff", id: "path20" }, void 0) }), void 0));
    }
}
